import { render, staticRenderFns } from "./ListBankMovements.vue?vue&type=template&id=2700839e"
import script from "./ListBankMovements.vue?vue&type=script&lang=js"
export * from "./ListBankMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports